import Empty from './Empty.component';

export default Empty;